export{ FooterNavProps } from "./footer-nav/footer-nav.props";
export { HeaderNavProps} from "./header-nav/header-nav.props";
export { ItemNavProps} from "./item-nav/item-nav.props";

export const name_header = "HeaderNavComponent";
export const name_footer = "FooterNavComponent";
export const name_item = "ItemNavComponent";
